import { CustomerType } from "../types"; // Adjust the import based on your types
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all customers
export const getCustomers = async (branch_id?: string | number) => {
  const url = branch_id
    ? `${ServiceEndpoints.CUSTOMERS}?branch_id=${branch_id}`
    : ServiceEndpoints.CUSTOMERS;
  return axios
    .get(url)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new customer
export const createCustomer = async (data: {
  name: string;
  email: string;
  phone: string;
}) => {
  return axios
    .post(ServiceEndpoints.CUSTOMERS, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing customer
export const updateCustomer = async (id: string, data: CustomerType) => {
  const customerData = data;

  return axios
    .put(`${ServiceEndpoints.CUSTOMERS}/${id}`, customerData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a customer by their ID
export const getCustomerById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.CUSTOMERS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a customer
export const deleteCustomer = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.CUSTOMERS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
